/**
 * Created by Owner on 2016/8/6.
 * 直选组合
 *  selectArea: {
          layout: [
            {
              title: "千位",
              no: "0|1|2|3|4|5|6|7|8|9"
            },
            {
              title: "百位",
              no: "0|1|2|3|4|5|6|7|8|9"
            },
            {
              title: "千位",
              no: "0|1|2|3|4|5|6|7|8|9"
            },
            {
              title: "百位",
              no: "0|1|2|3|4|5|6|7|8|9"
            }
          ],
          noBigIndex: 5
 */
import {Component} from '@angular/core';
import {LotteryMathZXFSComponent} from "./zxfs";
import {LotteryMath} from "./lotteryMath";

@Component({
  selector: 'lottery-math-zxzh',
  templateUrl: 'selectMath.html',
})
export class LotteryMathZXZHComponent extends LotteryMathZXFSComponent implements LotteryMath {
  ngOnInit() {
  }

  changeTotal(selectInfo:any) {
    let mname = this.selectAreaOption["mname"];
    let tmpTotal: number = 1;
    this.children.toArray().every(child=> {
      if (child.selectNo.length == 0) {
        tmpTotal = 0;
        return false;
      } else {
        tmpTotal *= child.selectNo.length;
        return true;
      }
    });
    tmpTotal *= parseInt(mname.charAt(mname.length - 1));
    this.setTotal(tmpTotal);
  }
}



// WEBPACK FOOTER //
// ./src/component/+lotteryMath/zxzh.ts